export default {
  name: 'StatusBar',
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentStep() {
      return this.steps.findIndex(step => step.status === true) != -1 ? this.steps.findIndex(step => step.status === true) : -1;
    },
    currentTitle() {
      return this.steps[this.currentStep - 1]?.title || '';
    }
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    }
  }
};